import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../RegulatoryPartners.css';

const RegulatoryPartners = () => {
  const { language } = useLanguage();
  const pl = language === 'pl';
  
  const partners = [
    {
      name: 'European Central Bank',
      url: 'https://www.ecb.europa.eu',
      logo: '/logos/ecb.png'
    },
    {
      name: 'INTOSAI',
      url: 'https://www.intosai.org/index.html',
      logo: '/logos/intosai.svg'
    },
    {
      name: 'ESMA',
      url: 'https://www.esma.europa.eu',
      logo: '/logos/esma.png'
    },
    {
      name: 'ASIC',
      url: 'https://asic.gov.au',
      logo: '/logos/asic.png'
    },
    {
      name: 'FCA',
      url: 'https://www.fca.org.uk',
      logo: '/logos/fca.png'
    },
    {
      name: 'SEC',
      url: 'https://www.sec.gov',
      logo: '/logos/sec.png'
    }
  ];

  return (
    <section id="authorities" className="tb-authorities" aria-labelledby="tb-authorities-title">
      <div className="tb-container">
        <div className="tb-authorities-heading">
          <h2 id="tb-authorities-title">{pl ? 'Instytucje i nadzór finansowy' : 'Financial authorities and public institutions'}</h2>
          <p>{pl ? 'Oficjalne strony i informacje dla konsumentów.' : 'Official websites and consumer information.'}</p>
        </div>
        
        <ul className="tb-authorities-list">
          {partners.map((partner, index) => (
            <li key={partner.name}>
            <a
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`tb-authority tb-authority--${index}`}
              aria-label={`${partner.name} (${pl ? 'oficjalna strona, otwiera się w nowej karcie' : 'official website, opens in a new tab'})`}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                loading="lazy"
                width="160"
                height="100"
              />
            </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RegulatoryPartners;
